import Pill from './Pill';

export { Pill };
export default Pill;
